import React, { useState, useEffect, useRef } from 'react';
import { announcementService, categoryVisual } from '../../services/announcement.service';
import '../../pages/announcements/AnnouncementsPage.css';

/**
 * Panel açılışında gösterilen önemli duyuru.
 *
 * YÖNLENDİRME YAPMAZ: açılışta kullanıcıyı başka sayfaya atmak akışı keser. Kart yerinde
 * gösterilir; kullanıcı isterse "Detaya git" ile duyuru sayfasına geçer.
 *
 * Oturum başına BİR kez sorulur (ref kilidi). Kalıcı "bir daha gösterme" kararı sunucudaki
 * okundu damgasıdır.
 */
export default function AnnouncementPopup({ onNavigate }) {
    const [item, setItem] = useState(null);
    const asked = useRef(false);

    useEffect(() => {
        if (asked.current) return;
        asked.current = true;

        let alive = true;

        // Servis erişilemezse success:false döner — panel açılışı kesilmez.
        announcementService.popup().then((res) => {
            if (alive && res?.success && res.data) setItem(res.data);
        });

        return () => { alive = false; };
    }, []);

    if (!item) return null;

    const visual = categoryVisual(item.category);

    const close = () => {
        announcementService.markRead(item.id);
        setItem(null);
    };

    const openDetail = () => {
        announcementService.markRead(item.id);
        setItem(null);
        onNavigate?.('announcements');
    };

    return (
        <div className="fan-overlay" role="dialog" aria-modal="true" onMouseDown={close}>
            <div className="fan-modal" onMouseDown={(e) => e.stopPropagation()}>
                {item.imageUrl && <img className="fan-modal-image" src={item.imageUrl} alt="" />}

                <div className="fan-modal-body">
                    <span className="fan-badge" style={{ background: visual.bg, color: visual.color }}>
                        {item.categoryText || visual.label}
                    </span>

                    <h2>{item.title}</h2>
                    <p>{item.summary}</p>
                </div>

                <div className="fan-modal-actions">
                    <button className="fan-btn-ghost" onClick={close}>Kapat</button>
                    <button className="fan-btn-primary" onClick={openDetail}>Detaya git</button>
                </div>
            </div>
        </div>
    );
}
